<template>
    <v-autocomplete
            hide-details="auto"
            v-model="picked"
            :items="items"
            item-value="id"
            item-text="name"
            outlined
            hide-no-data
            :error-messages="errors"
            :loading="isLoading"
            @change="onChange"
            v-bind="$attrs"
            class="pb-1"
    ></v-autocomplete>
</template>

<script>
import ContentAppService from '@/services/content-app.service.js';

export default {
  name: "ContentAppInput",
  props: {
    value: {},
    label: { type: String, default: 'Sélectionnez'},
    errors: { type: Array, default: ()=> ([])},
  },
  data() {
    return {
      picked: [],
      isLoading: false,
      items: [],
    }
  },
  created() {
    this.loadListItem();
  },
  methods: {
    async loadListItem() {
      const _this = this;

      this.isLoading = true;

      try {
        const {data} = await ContentAppService.getList();
        let listData = [];
        data.data.forEach(item => {
           listData.push({'id': item.id , 'name': item.title })
        });

        _this.items = listData;
      } catch (e) {
          this.handleError(e)
      }

      this.isLoading = false;
    },
    onChange(event) {
      let c = this.items.find(item => item.id === event);
      this.$emit('input', c);
    }
  },
  watch: {
  }
}
</script>

<style scoped>

</style>
